import { NavLink } from "react-router-dom";
import { t } from "../services/i18n";

const items = [
  { to: "/", label: "common.home", icon: "\u2302" },
  { to: "/routine", label: "common.routine", icon: "\u25CB" },
  { to: "/help", label: "common.help", icon: "?" }
];

export default function BottomNavigation() {
  return (
    <nav className="bottom-nav" aria-label="Main">
      {items.map((it) => (
        <NavLink key={it.to} to={it.to} end={it.to === "/"}>
          <span aria-hidden="true">{it.icon}</span>
          {t(it.label)}
        </NavLink>
      ))}
    </nav>
  );
}
